import * as actions from '../../actions/types';

const INITIAL_STATE = {
    customerDashboard: {
        get: {
            loading: false,
            reset: false,
            success: {
                ok: false,
                data: null,
            },
            failure: {
                error: false,
                message: '',
            },
        }
    }
};

const customerDashboardReducers = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case actions.GET_CUSTOMER_DASHBOARD_LOADING:
            return {
                ...state,
                customerDashboard: {
                    ...state.customerDashboard,
                    get: {
                        ...state.customerDashboard.get,
                        loading: true,
                        reset: false,
                        success: {
                            ...state.customerDashboard.get.success,
                            ok: false,
                        },
                        failure: {
                            error: false,
                            message: '',
                        },
                    },
                },
            };
        case actions.GET_CUSTOMER_DASHBOARD_SUCCESS:
            return {
                ...state,
                customerDashboard: {
                    ...state.customerDashboard,
                    get: {
                        ...state.customerDashboard.get,
                        loading: false,
                        reset: false,
                        success: {
                            ...state.customerDashboard.get.success,
                            ok: true,
                            data: action.payload,
                        },
                        failure: {
                            error: false,
                            message: '',
                        },
                    },
                },
            };
        case actions.GET_CUSTOMER_DASHBOARD_FAILURE:
            return {
                ...state,
                customerDashboard: {
                    ...state.customerDashboard,
                    get: {
                        ...state.customerDashboard.get,
                        loading: false,
                        reset: false,
                        success: {
                            ...state.customerDashboard.get.success,
                            ok: false,
                            data: null,
                        },
                        failure: {
                            error: true,
                            message: action.payload.message,
                        },
                    },
                },
            };
        case actions.GET_CUSTOMER_DASHBOARD_RESET:
            return {
                ...state,
                customerDashboard: {
                    ...state.customerDashboard.get,
                    post: {
                        ...INITIAL_STATE.customerDashboard.get,
                        reset: true,
                    },
                },
            }
        case actions.FILTER_ON_GOING_TASKS_LOADING:
            return {
                ...state,
                customerDashboard: {
                    ...state.customerDashboard,
                    get: {
                        ...state.customerDashboard.get,
                        loading: false,
                        reset: false,
                        success: {
                            ...state.customerDashboard.get.success,
                            ok: true,
                            data: {
                                ...state.customerDashboard.get.success.data,
                            },
                        },
                        failure: {
                            error: false,
                            message: '',
                        },
                    },
                },
            };
        case actions.FILTER_ON_GOING_TASKS_SUCCESS:
            return {
                ...state,
                customerDashboard: {
                    ...state.customerDashboard,
                    get: {
                        ...state.customerDashboard.get,
                        loading: false,
                        reset: false,
                        success: {
                            ...state.customerDashboard.get.success,
                            ok: true,
                            data: {
                                ...state.customerDashboard.get.success.data,
                                on_going_task: action.payload
                            },
                        },
                        failure: {
                            error: false,
                            message: '',
                        },
                    },
                },
            };
        case actions.FILTER_ON_GOING_TASKS_FAILURE:
            return {
                ...state,
                customerDashboard: {
                    ...state.customerDashboard,
                    get: {
                        ...state.customerDashboard.get,
                        loading: false,
                        reset: false,
                        success: {
                            ...state.customerDashboard.get.success,
                            ok: true,
                            data: {
                                ...state.customerDashboard.get.success.data,
                            },
                        },
                        failure: {
                            error: false,
                            message: '',
                        },
                    },
                },
            };
    }
    return state;
}

export default customerDashboardReducers;
